import { useState } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const mensagem = `https://exatocalculos.com.br
  *Olá! Tudo bem?*
Vi seu site e tenho interesse nos serviços de cálculos trabalhistas.

Gostaria de entender melhor como funciona o atendimento de vocês e quais tipos de cálculos realizam. Tenho algumas demandas e acredito que possa ser interessante trabalharmos juntos.

Pode me passar mais informações?`;

  return (
    <a
  href={`https://wa.me/5511994688228?text=${encodeURIComponent(mensagem)}`}
  target="_blank"
  rel="nofollow noopener noreferrer"
  className="fixed bottom-7 right-7 z-50 flex items-center gap-3 cursor-pointer group"
  onMouseEnter={() => setHovered(true)}
  onMouseLeave={() => setHovered(false)}
>
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 whitespace-nowrap bg-gray-900 text-white text-xs font-medium px-3 py-2 rounded-lg ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
        }`}
      >
        Falar no WhatsApp
      </div>

      {/* Button */}
      <div className="relative">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full animate-ping opacity-30" style={{ background: '#25d366' }}></span>
        <div
          className="w-14 h-14 flex items-center justify-center rounded-full text-white transition-all duration-200 group-hover:scale-110"
          style={{ background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)', boxShadow: '0 4px 20px rgba(37,211,102,0.4)' }}
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </div>
      </div>
    </a>
  );
}
